module.exports = __webpack_public_path__ + "assets/img/yoomoney.548bd55a.svg";